// Branch Finder - postcode geocoding, distance sort, Leaflet map
(function() {
  'use strict';

  var state = {
    branches: [],
    map: null,
    markers: {},
    userMarker: null,
    userLatLng: null,
  };

  function setStatus(msg, type) {
    var el = document.querySelector('[data-branch-status]');
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'branch-finder__status' + (type ? ' is-' + type : '');
  }

  function distanceKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) *
            Math.sin(dLng/2) * Math.sin(dLng/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }

  function kmToMiles(km) { return km * 0.621371; }

  function slugify(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function branchHoursHTML(branch) {
    var hours = branch.hours || {};
    var monFri = hours.mon_fri || '';
    var saturday = hours.saturday || '';
    if (!monFri && !saturday) return '';

    return '<div class="branch-card__hours" aria-label="Opening hours">' +
      (monFri ? '<span><strong>Mon-Fri</strong> ' + monFri + '</span>' : '') +
      (saturday ? '<span><strong>Sat</strong> ' + saturday + '</span>' : '') +
      '</div>';
  }

  function renderList(branches, userLocated) {
    var list = document.querySelector('[data-branch-list]');
    if (!list) return;
    list.innerHTML = '';

    branches.forEach(function(b, idx) {
      var slug = b.slug || slugify(b.name);
      var card = document.createElement('a');
      card.className = 'branch-card' + (userLocated && idx === 0 ? ' is-nearest' : '');
      card.href = window.__branchRootUrl + slug;

      var distanceHTML = '';
      if (typeof b.distanceKm === 'number') {
        var miles = kmToMiles(b.distanceKm).toFixed(1);
        distanceHTML = '<span class="branch-card__distance">' + miles + ' mi</span>';
      }

      var phoneHref = (b.phone || '').replace(/\s+/g, '');
      var mapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(b.address || '');

      card.innerHTML =
        '<div class="branch-card__header">' +
          '<h3 class="branch-card__name">' + b.name + '</h3>' +
          distanceHTML +
        '</div>' +
        '<p class="branch-card__address">' + (b.address || '') + '</p>' +
        branchHoursHTML(b) +
        '<div class="branch-card__meta">' +
          (b.phone ? '<a href="tel:' + phoneHref + '">' + b.phone + '</a>' : '') +
          (b.email ? '<a href="mailto:' + b.email + '">' + b.email + '</a>' : '') +
        '</div>' +
        '<div class="branch-card__actions">' +
          '<span class="branch-card__btn branch-card__btn--primary">View details</span>' +
          '<a href="' + mapsUrl + '" target="_blank" rel="noopener" class="branch-card__btn" onclick="event.stopPropagation()">Get directions</a>' +
        '</div>';

      card.addEventListener('mouseenter', function() {
        if (state.markers[slug]) state.markers[slug].openPopup();
      });

      list.appendChild(card);
    });
  }

  function fitMapToBranches() {
    if (!state.map || !state.branches.length) return;
    var geoBranches = state.branches.filter(function(b){ return b.lat && b.lng; });
    if (!geoBranches.length) return;
    var bounds = L.latLngBounds(geoBranches.map(function(b) { return [b.lat, b.lng]; }));
    if (state.userLatLng) bounds.extend(state.userLatLng);
    state.map.fitBounds(bounds, { padding: [30, 30] });
  }

  function initMap() {
    var mapEl = document.getElementById('branchFinderMap');
    if (!mapEl || typeof L === 'undefined') return;

    state.map = L.map(mapEl, {
      center: [54.5, -2.5],
      zoom: 6,
      scrollWheelZoom: false,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(state.map);

    var brandIcon = L.divIcon({
      className: 'tpc-branch-marker',
      html: '<div style="background:var(--color-brand-accent);border:2px solid var(--color-brand-primary);border-radius:50%;width:24px;height:24px;box-shadow:0 2px 4px rgba(0,0,0,0.3);"></div>',
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12],
    });

    state.branches.forEach(function(b) {
      if (typeof b.lat !== 'number' || typeof b.lng !== 'number') return;
      var slug = b.slug || slugify(b.name);
      var m = L.marker([b.lat, b.lng], { icon: brandIcon }).addTo(state.map);
      var popupHTML =
        '<strong>' + b.name + '</strong>' +
        '<div style="font-size:0.85rem;margin-bottom:0.3rem;">' + (b.address || '') + '</div>' +
        '<a href="' + window.__branchRootUrl + slug + '" style="font-weight:700;color:var(--color-brand-primary);text-decoration:underline;">View branch →</a>';
      m.bindPopup(popupHTML);
      state.markers[slug] = m;
    });

    fitMapToBranches();
  }

  function sortAndRender(byDistance) {
    var sorted = state.branches.slice();
    if (byDistance && state.userLatLng) {
      sorted.forEach(function(b) {
        if (typeof b.lat === 'number' && typeof b.lng === 'number') {
          b.distanceKm = distanceKm(state.userLatLng[0], state.userLatLng[1], b.lat, b.lng);
        }
      });
      sorted.sort(function(a, b) { return (a.distanceKm || Infinity) - (b.distanceKm || Infinity); });
    } else {
      sorted.sort(function(a, b) { return a.name.localeCompare(b.name); });
      sorted.forEach(function(b) { delete b.distanceKm; });
    }
    renderList(sorted, byDistance && !!state.userLatLng);
  }

  function placeUserMarker(lat, lng) {
    if (!state.map) return;
    if (state.userMarker) state.map.removeLayer(state.userMarker);
    var userIcon = L.divIcon({
      className: 'tpc-user-marker',
      html: '<div style="background:#3b82f6;border:3px solid #fff;border-radius:50%;width:18px;height:18px;box-shadow:0 0 0 4px rgba(59,130,246,0.35);"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
    });
    state.userMarker = L.marker([lat, lng], { icon: userIcon }).addTo(state.map);
    state.userLatLng = [lat, lng];
    state.map.setView([lat, lng], 9);
  }

  function normaliseSearch(value) {
    return (value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function compactSearch(value) {
    return normaliseSearch(value).replace(/\s+/g, '');
  }

  var fallbackLocations = {
    london: [51.5074, -0.1278],
    'greater london': [51.5074, -0.1278],
    'central london': [51.5074, -0.1278],
    'west london': [51.5074, -0.3643],
    hounslow: [51.4648, -0.3643],
    middlesex: [51.4890, -0.4490],
    heathrow: [51.4700, -0.4543],
    yorkshire: [53.8008, -1.5491],
    'west yorkshire': [53.8008, -1.5491],
    leeds: [53.8008, -1.5491],
    oxford: [51.7520, -1.2577],
    oxfordshire: [51.7520, -1.2577],
    birmingham: [52.4862, -1.8904],
    midlands: [52.4862, -1.8904],
    'west midlands': [52.4862, -1.8904],
    coventry: [52.4068, -1.5197],
    leicester: [52.6369, -1.1398],
    gloucester: [51.8642, -2.2382],
    wales: [52.5167, -3.3000],
    'mid wales': [52.5167, -3.3000],
    newtown: [52.5167, -3.3000],
    telford: [52.6784, -2.4453],
    shropshire: [52.7064, -2.7418],
    newcastle: [54.9783, -1.6178],
    'newcastle upon tyne': [54.9783, -1.6178],
    'north east': [54.9783, -1.6178],
    sunderland: [54.9069, -1.3838],
    hartlepool: [54.6917, -1.2129],
    cramlington: [55.0867, -1.5853],
    peterborough: [52.5695, -0.2405],
    redditch: [52.3080, -1.9409],
    tamworth: [52.6336, -1.6910],
    wolverhampton: [52.5862, -2.1288],
    'high wycombe': [51.6286, -0.7482],
    wycombe: [51.6286, -0.7482]
  };

  var postcodeAreaLocations = {
    b: [52.4862, -1.8904],
    b11: [52.4535, -1.8467],
    b77: [52.6336, -1.6910],
    b98: [52.3080, -1.9409],
    cv: [52.4068, -1.5197],
    de: [52.9225, -1.4746],
    dl: [54.6369, -1.6988],
    gl: [51.8642, -2.2382],
    hp: [51.6286, -0.7482],
    le: [52.6369, -1.1398],
    ls: [53.8008, -1.5491],
    ne23: [55.0867, -1.5853],
    ne33: [54.9980, -1.4210],
    ne: [54.9783, -1.6178],
    ox: [51.7520, -1.2577],
    pe: [52.5695, -0.2405],
    sr: [54.9069, -1.3838],
    sy: [52.5167, -3.3000],
    tf: [52.6784, -2.4453],
    ts: [54.6917, -1.2129],
    tw: [51.4648, -0.3643],
    wv: [52.5862, -2.1288],
    e: [51.5074, -0.1278],
    ec: [51.5155, -0.0922],
    n: [51.5074, -0.1278],
    nw: [51.5074, -0.1278],
    se: [51.5074, -0.1278],
    sw: [51.5074, -0.1278],
    w: [51.5074, -0.1278],
    wc: [51.5074, -0.1278]
  };

  function lookupPostcode(postcode) {
    var clean = postcode.trim().toUpperCase();
    return fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(clean))
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(data) {
        if (data && data.result) {
          return { lat: data.result.latitude, lng: data.result.longitude, label: clean };
        }
        return Promise.reject('Postcode not found');
      });
  }

  function lookupOutcode(query) {
    var clean = compactSearch(query).toUpperCase();
    return fetch('https://api.postcodes.io/outcodes/' + encodeURIComponent(clean))
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(data) {
        if (data && data.result) {
          return { lat: data.result.latitude, lng: data.result.longitude, label: clean };
        }
        return Promise.reject('Outcode not found');
      });
  }

  function lookupPlace(query) {
    return fetch('https://api.postcodes.io/places?q=' + encodeURIComponent(query))
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(data) {
        var result = data && data.result && data.result[0];
        if (result && typeof result.latitude === 'number' && typeof result.longitude === 'number') {
          return { lat: result.latitude, lng: result.longitude, label: result.name_1 || query };
        }
        return Promise.reject('Place not found');
      });
  }

  function lookupFallback(query) {
    var q = normaliseSearch(query);
    var qCompact = compactSearch(query);
    var match = fallbackLocations[q] || postcodeAreaLocations[qCompact];
    if (!match) {
      Object.keys(fallbackLocations).some(function(key) {
        if (q.indexOf(key) !== -1 || key.indexOf(q) !== -1) {
          match = fallbackLocations[key];
          return true;
        }
        return false;
      });
    }
    if (!match) {
      Object.keys(postcodeAreaLocations).some(function(key) {
        if (qCompact.indexOf(key) === 0) {
          match = postcodeAreaLocations[key];
          return true;
        }
        return false;
      });
    }
    if (match) return Promise.resolve({ lat: match[0], lng: match[1], label: query });
    return Promise.reject('Location not found');
  }

  function lookupLocation(query) {
    setStatus('Finding nearest branch…');
    return lookupPostcode(query)
      .catch(function() { return lookupOutcode(query); })
      .catch(function() { return lookupPlace(query); })
      .catch(function() { return lookupFallback(query); });
  }

  function searchBranchesByText(query) {
    var q = normaliseSearch(query);
    var qCompact = compactSearch(query);
    return state.branches.filter(function(b) {
      var hay = normaliseSearch([b.name, b.address, b.postcode, b.region, b.admin_district].join(' '));
      var hayCompact = compactSearch(hay);
      return hay.indexOf(q) !== -1 || hayCompact.indexOf(qCompact) !== -1;
    }).sort(function(a, b) {
      return a.name.localeCompare(b.name);
    });
  }

  function handleSearch(e) {
    e.preventDefault();
    var input = document.getElementById('branchPostcode');
    if (!input || !input.value.trim()) {
      setStatus('Please enter a postcode', 'error');
      return;
    }
    var query = input.value.trim();
    lookupLocation(query)
      .then(function(result) {
        placeUserMarker(result.lat, result.lng);
        sortAndRender(true);
        setStatus('Showing branches nearest to ' + (result.label || query), 'success');
      })
      .catch(function() {
        var matches = searchBranchesByText(query);
        if (!matches.length) {
          setStatus('Could not find that place. Try a postcode, town, city or county.', 'error');
          return;
        }
        state.userLatLng = null;
        renderList(matches, false);
        setStatus('Showing branch matches for ' + query, 'success');
      });
  }

  function handleGeolocate() {
    if (!navigator.geolocation) {
      setStatus('Geolocation not supported by your browser', 'error');
      return;
    }
    setStatus('Getting your location…');
    navigator.geolocation.getCurrentPosition(
      function(pos) {
        placeUserMarker(pos.coords.latitude, pos.coords.longitude);
        sortAndRender(true);
        setStatus('Showing branches nearest to you', 'success');
      },
      function() { setStatus('Could not get your location. Please enter a postcode.', 'error'); },
      { enableHighAccuracy: false, timeout: 8000 }
    );
  }

  function loadData() {
    fetch(window.__branchFinderDataUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        state.branches = data.branches || [];
        sortAndRender(false);
        if (typeof L !== 'undefined') {
          initMap();
        } else {
          var check = setInterval(function() {
            if (typeof L !== 'undefined') {
              clearInterval(check);
              initMap();
            }
          }, 100);
        }
      })
      .catch(function(err) {
        console.error('Failed to load branches', err);
        setStatus('Could not load branch data', 'error');
      });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var form = document.querySelector('[data-branch-search]');
    if (form) form.addEventListener('submit', handleSearch);

    var geoBtn = document.querySelector('[data-branch-geolocate]');
    if (geoBtn) geoBtn.addEventListener('click', handleGeolocate);

    loadData();
  });
})();
